import styled from "styled-components";

const TimelineClipList = styled.div`
    padding: 8px;
    display: flex;
    gap: 10px;
`

export default TimelineClipList
